import { createContentPropTypes } from '../../../helpers/content';

const content = {
	PageHeader: 'Transactions submitted',
	PageSubHeader:
		'Your transactions have now been submitted – you can see more information about each one below. If you want to check if a transaction’s gone through yet, please click ‘Check payment status’',
	accountsButtonLabel: 'Go to your accounts',
	anotherPaymentButtonLabel: 'Make another payment or transfer',
	paymentStatusButtonLabel: 'Check payment status',
	AuthorisationBodyMsg: 'Please login to your mobile banking app to provide authorisation.',
	ItemsAwaitingAuthorisationLabel: ' Items Awaiting Authorisation',
	SubmittedLabel: 'Submitted',
	FailedLabel: 'Failed',
	PendingLabel: 'Pending',
	paymentSubmittedHeader: 'Payment Submitted',
	authorisationRequired: 'Authorisation Required',
	submissionErrorHeader: 'Payment Failed',
	submissionOnHoldHeader: 'Pending',
	submissionMissedChapsDeadlineErrorText:
		'This payment cannot be submitted as it has missed the cut off for today. Please retry with a different submission date',
	submissionErrorText: 'We have been unable to process your payment, please resubmit',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	refLabel: 'Reference',
	dateLabel: 'Date',
	typeLabel: 'Type',
	feesLabel: 'Fees',
	authorisationNavigation:
		'To authorise payments using your security token, please continue to the ‘Payment status and history’ screen.',
	batchAuthorisationHardToken: 'Please continue to the ‘Payment status and history’ screen to provide authorisation.',
	batchAuthorisationSoftToken: 'Please login to your mobile banking app to provide authorisation.',
	authoriseButtonText: 'Continue to authorise',
	softToken: 'Log in to your mobile banking app.',
	hardToken: 'Use your security token.',
	fileUploadFirstInstruction: 'This uploaded batch payment will need authorised in two stages.',
	fileUploadSecondInstruction: '1. Internet banking',
	fileUploadThirdInstruction: 'Review and confirm the payment details are correct.',
	fileUploadFourthInstruction: '2. Mobile banking app',
	fileUploadFifthInstruction: 'Log in to your mobile banking app to provide final authorisation.',
	fileUploadReviewButton: 'Review and confirm',
	fileUploadTwoStepInstructionHeading: 'Two-step authorisation required',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
